<template>
  <v-row no-gutters>
    <v-col cols="12" class="mt-2">
      <v-row no-gutters dense>
        <v-col cols="2" class="pa-2">
          <v-btn outlined text icon @click="printPreview" color="primary">
            <v-icon>print</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="4" md="2" class="ml-2">
          <v-text-field
            dense
            label="BarCode Size : "
            v-model.number="width"
            outlined
            type="number"
          />
        </v-col>
        <!-- <v-col cols="4" md="2" class="ml-2"> -->
        <!-- <v-text-field dense label="Padding" v-model.number="padding" type="number" outlined /> -->
        <!-- </v-col> -->
      </v-row>
      <v-divider />
      <v-row no-gutters>
        <v-col offset-md="4" cols="12" md="4" class="white">
          <template v-if="icon">
            <div id="printView">
              <voucher-layout
                :voucher="voucher"
                :company="company"
                :width="width"
                :height="width"
                :file="companyProfile"
                v-for="voucher in vouchers"
                v-bind:key="voucher.itemId"
                class="pa-1"
              />
            </div>
          </template>
          <template v-else>
            <div id="printView">
              <no-icon-voucher-layout
                :voucher="voucher"
                :company="company"
                :width="width"
                :height="width"
                :file="companyProfile"
                v-for="voucher in vouchers"
                v-bind:key="voucher.itemId"
                class="pa-1"
              />
            </div>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import printJS from "print-js";
import Hashids from "hashids";
import orderService from "../service/OrderService";
const VoucherLayout = () => import("../components/VoucherLayout.vue");
const NoIconVoucherLayout = () =>
  import("../components/NoIconVoucherLayout.vue");
import companyInfoService from "../service/CompanyInfoService";
import axios from "../config";

let hashids = new Hashids("info@deli@ry");

export default {
  mounted: function() {
    this.getCompanyInfo();
    let ids = hashids.decode(this.$route.query.ids);
    this.icon = this.$route.query.icon === "true";
    this.ids = ids.map(m => {
      let obj = {
        id: m,
        code: hashids.encode(m)
      };
      return obj;
    });
    console.log(this.icon);
    orderService.getVoucherById(ids).then(data => {
      this.vouchers = this.vouchers.filter(v => false);
      data.forEach(v => {
        v.id = v.itemId;
        v.code = hashids.encode(v.id);
      });
      this.vouchers.push(...data);
    });
  },
  data() {
    return {
      ids: [],
      icon: false,
      width: 120,
      height: 120,
      padding: 0,
      vouchers: [],
      company: {
        companyName: "",
        phoneNo: ""
      },
      companyProfile: ""
    };
  },
  computed: {},
  components: {
    "voucher-layout": VoucherLayout,
    "no-icon-voucher-layout": NoIconVoucherLayout
  },
  methods: {
    printPreview: function() {
      let config = {
        printable: "printView",
        type: "html",
        css: ["/css/barcode-gen.css"]
      };
      printJS(config);
    },
    getCompanyInfo: function() {
      companyInfoService.getCompanyInfo().then(response => {
        this.company = response;
        this.companyProfile = `${axios.defaults.baseURL}/companyLogo/${response.logo}`;
      });
    }
  }
};
</script>

<style>
</style>